<template>

  <AInputNumber
      class="n-input-number sms-code"
      ref="inputArr0"
      v-model:value="vc_values[0]"
      :controls="false"
      :maxlength="1"
      :placeholder="'-'"
      @keydown="allowOnlyNumbers($event, 0)"
      @blur="onBlur($event, 0)"
      @focus = "onFocus($event, 0)"
      v-bind:class="{ hoverEffect: isHovered0 }"/>
  
  <AInputNumber
      class="n-input-number sms-code"
      ref="inputArr1"
      v-model:value="vc_values[1]"
      :controls="false"
      :maxlength="1"
      :placeholder="'-'"
      @keydown="allowOnlyNumbers($event, 1)"
      @blur="onBlur($event, 1)"
      @focus = "onFocus($event, 1)"
      v-bind:class="{ hoverEffect: isHovered1 }"/>

  <AInputNumber
      class="n-input-number sms-code"
      ref="inputArr2"
      v-model:value="vc_values[2]"
      :controls="false"
      :maxlength="1"
      :placeholder="'-'"
      @keydown="allowOnlyNumbers($event, 2)"
      @blur="onBlur($event, 2)"
      @focus = "onFocus($event, 2)"
      v-bind:class="{ hoverEffect: isHovered2 }"/>

  <AInputNumber
      class="n-input-number sms-code"
      ref="inputArr3"
      v-model:value="vc_values[3]"
      :controls="false"
      :maxlength="1"
      :placeholder="'-'"
      @keydown="allowOnlyNumbers($event, 3)"
      @blur="onBlur($event, 3)"
      @focus = "onFocus($event, 3)"
      v-bind:class="{ hoverEffect: isHovered3 }"/>

  <AInputNumber
      class="n-input-number sms-code"
      ref="inputArr4"
      v-model:value="vc_values[4]"
      :controls="false"
      :maxlength="1"
      :placeholder="'-'"
      @keydown="allowOnlyNumbers($event, 4)"
      @blur="onBlur($event, 4)"
      @focus = "onFocus($event, 4)"
      v-bind:class="{ hoverEffect: isHovered4 }"/>

  <AInputNumber
      class="n-input-number sms-code"
      ref="inputArr5"
      v-model:value="vc_values[5]"
      :controls="false"
      :maxlength="1"
      :placeholder="'-'"
      @keydown="allowOnlyNumbers($event, 5)"
      @blur="onBlur($event, 5)"
      @focus = "onFocus($event, 5)"
      v-bind:class="{ hoverEffect: isHovered5 }"/>

</template>

<script setup>
import { ref } from 'vue';
import { InputNumber as AInputNumber } from 'ant-design-vue/es';
import {isNumber} from "lodash-es";

const props = defineProps({
  value: [String, Number],
  title: String,
  align: { type: String, default: 'left' },
  replacement: { type: String, default: '-' },
});
const emit = defineEmits(['afterFinished']);
const vc_values = ref([]);

const inputArr0 = ref();
const inputArr1 = ref();
const inputArr2 = ref();
const inputArr3 = ref();
const inputArr4 = ref();
const inputArr5 = ref();

const isHovered0 = ref(false);
const isHovered1 = ref(false);
const isHovered2 = ref(false);
const isHovered3 = ref(false);
const isHovered4 = ref(false);
const isHovered5 = ref(false);

const inputArr = [inputArr0, inputArr1, inputArr2, inputArr3, inputArr4, inputArr5];
const hoverArr = [isHovered0, isHovered1, isHovered2, isHovered3, isHovered4, isHovered5];

function onBlur(event, idx){
  const hv = hoverArr[idx];
  hv.value = true;
}
function onFocus(event, idx){
  const hv = hoverArr[idx];
  hv.value = false;
}
function allowOnlyNumbers(event, index){
  const key = event.key;
  // 允许输入数字（0-9）
  if (!/^\d$/.test(key) && key !== "Backspace" ) {
    event.preventDefault(); // Block
    return ;
  }
  const index2 = index + 1;
  
  if( key !== "Backspace") {
    setTimeout(() => {
        let all = true;
        for (let i = 0; i < inputArr.length; i++) {
          const v = vc_values.value[i];
          
          if(!isNumber(v)) {
            all = false;
            break;
          }
        }
      
      if(index <5 && (!all)){
        const t = inputArr[index2];
        t.value.focus();
      }
      
      if(all){
        // call send sms verify code
        const vcode = vc_values.value.join('');
        emit('afterFinished', vcode);
        blurAll();
      }else {
        //NOP
      }
      
    }, 50);
    
    return ;
  }
  
  // 空时点击Backspace，删除前一个框 
  if( key === "Backspace"){
    const cur = vc_values.value[index];
    if(!cur && (index -1)>=0){
      // const prev = vc_values.value[index-1];
      vc_values.value[index-1] = undefined;
      const t = inputArr[index-1];
      t.value.focus();
    }
  }

}

function blurAll(){
  inputArr0.value.blur();
  inputArr1.value.blur();
  inputArr2.value.blur();
  inputArr3.value.blur();
  inputArr4.value.blur();
  inputArr5.value.blur();
}

</script>

<script>
export default {
  name: 'NInputVCode',
};
</script>
<style lang="less">
.sms-code {
  width: 38px;
  height: 38px;
  margin: 2px;
  border-radius: 8px !important;
  
  .ant-input-number-input-wrap {
    width: 100%;
    height: 100%;
    .ant-input-number-input {
      width: 100%;
      height: 100%;
      text-align: center;
      font-weight: bold;
      font-size: 20px;
    }
  }
}


.hoverEffect:hover {
  //border-color: var(--ant-primary-5) !important;
  border-color: #d9d9d9 !important;
  border-right-width: 1px !important;
}
</style>